import { makeCancellable, takeLatest } from 'vuex-cancellable-actions'

import { apiPost } from '../api'

export default { // events for chart
  namespaced: true,
  state: {},
  getters: {
    isWorking: (state, getters, rootState) =>
      rootState.user.current && rootState.user.current.isWorking,
  },
  mutations: {},
  actions: makeCancellable({
    start: takeLatest(({ rootState, commit, dispatch }) =>
      apiPost({
        rootState,
        dispatch,
        url: `/api/work-time/start/`,
      })
        .then(() => commit(
          'user/setIsWorking',
          { isWorking: true },
          { root: true },
        ))),
    stop: takeLatest(({ rootState, commit, dispatch }) =>
      apiPost({
        rootState,
        dispatch,
        url: `/api/work-time/stop/`,
      })
        .then(() => commit(
          'user/setIsWorking',
          { isWorking: false },
          { root: true },
        ))),
  }),
}
